import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background: #21004d;
  padding: 60px 0 40px;
  margin-top: auto;
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 105px;

  @media (max-width: 1024px) {
    padding: 0 32px;
  }

  @media (max-width: 480px) {
    padding: 0 20px;
  }
`;

export const FooterContent = styled.div`
  width: 100%;
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
`;

export const FooterBrand = styled.div`
  .footer-logo {
    height: 32px;
    width: auto;
  }
`;

export const FooterNav = styled.div`
  display: flex;
  gap: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FooterNavLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  transition: color 0.3s ease;

  &:hover {
    color: #EBB800;
  }
`;

export const FooterCopyright = styled.div`
  p {
    color: white;
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 18px;
    margin: 0;
  }
`;

export const FooterPolicies = styled.div`
  display: flex;
  gap: 30px;

  a {
    color: white;
    text-decoration: none;
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 24px;
    font-weight: normal;
    transition: color 0.3s ease;

    &:hover {
      color: #EBB800;
    }
  }

  @media (max-width: 768px) {
    gap: 20px;
  }
`;